export const chunkedArray = (array,{chunkSize = 2}={})=>{
    const tmp = [];

    for( let i = 0; i < array.length; i+=chunkSize){
        tmp.push(array.slice(i,i+chunkSize));
    }
    return tmp;
}